import React from "react";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Popover from "./changePasswordPopUp";
import { history } from "../../../managers/history";
import { sessionManager } from "../../../managers/sessionManager";
import { connect } from "react-redux";
import { cookiesConstants, eventConstants } from "../../../constants";
import { dispatchAction } from "../../../utility";
import ChangePassword from "../../changepassword";
import Dialog from "@material-ui/core/Dialog";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import MuiDialogContent from "@material-ui/core/DialogContent";
import { withStyles } from "@material-ui/core/styles";
import PasswordDrawer from "./passwordDrawer";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  rootIcon: {
    borderRadius: '100%',
    marginTop: '1px',

  },
  paper: {
    
    "@media (min-width:768px) and (max-width:1024px)": {
      // top: "55px",
      overflow: "hidden !important",
      width: "100% !important",
    height: "100% !important",
    margin: 0,
    maxWidth: "100% !important",
    maxHeight: "none !important",
    borderRadius: "0",
    },
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
    borderRadius: '20px',
    marginRight: '10px',
  },
  popup: {
    top: '10px!important',
    left: '-57px!important',
    overflow: 'visible',
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      backgroundColor: 'var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
      boxShadow: "-1px -1px 1px #f5f5f5"
    },
  },
  iconButton: {
    "&:hover": {
      borderRadius: "50%",
    },
    Change: {
      color: "#001441",
    },
    topScrollPaper: {
      // margin:"35px",
      alignItems: "flex-start",
    },
    topPaperScrollBody: {
      verticalAlign: "top",
    },
  },
}));


const WebView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 1024px) {
    display: none;
  }
  @media (min-width: 1025px) {
    display: visible;
  }
`;

const TabView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 1024px) {
    display: visible;
    padding: 20px 20px 0px 20px;
  }
  @media (min-width: 1025px) {
    display: none;
  }
`;

const mapDispatchToProps = {
  logout: dispatchAction(eventConstants.LOGOUT_SUCCESS, {}),
};

const DialogContent = withStyles((theme) => ({
  root: {
    // width: "402px",
    height: "auto",
    paddingBottom:"26px"
    // display: "flex",
    // justifyContent: "center",
  },
}))(MuiDialogContent);

function MenuListComposition(props) {

  let profileImage = props?.user?.userDetails?.userDetails?.picture

  const logout = () => {
    console.log(
      sessionManager.getDataFromCookies(cookiesConstants.REMEMBER_ME),
      "remember me"
    );
    if (
      sessionManager.getDataFromCookies(cookiesConstants.REMEMBER_ME) ===
      "false"
    ) {
      sessionManager.removeDataFromCookies(cookiesConstants.EMAIL_ID);
      sessionManager.removeDataFromCookies(cookiesConstants.REMEMBER_ME);
      sessionManager.removeDataFromCookies(cookiesConstants.PASSWORD);
    }
    dispatchAction(eventConstants.LOGOUT_SUCCESS, {});
    sessionManager.removeDataFromCookies("accessToken");
    sessionManager.removeDataFromCookies(cookiesConstants.USER);
    sessionManager.removeDataFromCookies(cookiesConstants.IS_LOGIN);
    sessionManager.removeDataFromCookies("accessToken");
    sessionManager.removeDataFromCookies("userDetails");
    history.push("/");
  };
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleClickOpen = () => {
    setIsOpen(true);
  };

  const handleDialogClose = () => {
    setIsOpen(false);
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <div className={classes.root}>
      <div>
        <div
          className={classes.rootIcon}
          ref={anchorRef}
          aria-controls={open ? "menu-list-grow" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <img alt="body" src="/images/profilePic.png" className={classes.Avatar} />
        </div>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
          className={classes.popup}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom",
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="menu-list-grow"
                    onKeyDown={handleListKeyDown}
                  >
                    <div onClick={() => setOpen(!open)}>
                      <MenuItem
                        onClick={handleClickOpen}
                        className={classes.Change}
                      >
                        Change Password
                      </MenuItem>
                      {/* <Popover /> */}
                    </div>
                    <a
                      href=""
                      style={{ textDecoration: "none", color: "#001441" }}
                    >
                      {" "}
                      <MenuItem onClick={logout}>Logout</MenuItem>
                    </a>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>

        {/* {Dialog Box} */}
        <Dialog
          className="passDialogStyle"
          fullScreen={fullScreen}
          // onClose={handleDialogClose}
          aria-labelledby="customized-dialog-title"
          open={isOpen}
          classes={{
            scrollPaper: classes.topScrollPaper,
            paperScrollBody: classes.topPaperScrollBody,
            paper: classes.paper
          }}
          className="deeak"
        >
          <TabView>
            <div
              style={{
                height: "35px",
                boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
              }}
            >
              <PasswordDrawer user={profileImage}/>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "2.75rem",
              }}
            >
              <div className="changePass">Change Password </div>
              <div>
                <img
                  className="cursor-pointer pr-18"
                  onClick={handleDialogClose}
                  src="/images/redCross.svg"
                />
              </div>
            </div>
          </TabView>
          <DialogContent >
            <ChangePassword onClose={handleDialogClose} />
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}

export default connect(null, mapDispatchToProps)(MenuListComposition);
